import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'core/services/store.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-list-paginator',
  templateUrl: './list-paginator.component.html',
  styleUrls: ['./list-paginator.component.scss']
})
export class ListPaginatorComponent implements OnInit, OnChanges {
  @Input() listId: string;
  public listSubscription: Subscription;
  // todo remove input decorator
  @Input() page: number;
  @Input() pages: number;
  @Input() total: number;
  limit: number;
  @Input() elementsName: string;
  first: number;
  last: number;

  public visualizationMargin = 2;
  public pagesList: number[];
  public totalElementsLabel = '';

  public disableFirstPageArrow = true;
  public disablePreviousPageArrow = true;
  public disableLastPageArrow = true;
  public disableNextPageArrow = true;

  constructor(public translate: TranslateService) {}

  ngOnInit() {
    this.listSubscription = StoreService.get(this.listId).subscribe((data) => {
      const { page = 0, pages = 0, limit = 0, total = 0, elementsName = '' } = data || {};
      this.page = page;
      this.pages = pages;
      this.limit = limit;
      this.total = total;
      this.first = pages ? (page - 1) * limit + 1 : 0;
      this.last = Math.min(page * limit, total);
      this.elementsName = elementsName;
      this.disableFirstPageArrow = this.disablePreviousPageArrow = this.page <= 1 ? true : false;
      this.disableLastPageArrow = this.disableNextPageArrow = this.page === this.pages ? true : false;
    });
  }

  ngOnChanges(change) {
    this.pagesList = Array.from(new Array(this.pages), (val, index) => index + 1);
    this.translate
      .get('list.paginator.totalElements', { total: this.total ? this.total : 0 })
      .subscribe((res: string) => {
        this.totalElementsLabel = res;
      });
  }

  goToPage(page) {
    StoreService.merge(this.listId, { page, active: true });
  }
}
